export default __webpack_public_path__ + "static/media/done-24-px.7cbee0a2.svg";